import React from 'react';
import { useTranslation } from 'react-i18next';

type LanguageSwitcherProps = {
  className?: string;
};

export function LanguageSwitcher({ className = '' }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation();
  const lang = i18n.language?.startsWith('en') ? 'en' : 'ro';

  return (
    <div
      className={`flex rounded-lg border border-regina-gray-200 bg-white/95 p-0.5 shadow-md backdrop-blur-sm gap-0.5 ${className}`}
      role="group"
      aria-label={t('common.language')}
    >
      <button
        type="button"
        onClick={() => void i18n.changeLanguage('ro')}
        aria-pressed={lang === 'ro'}
        className={`px-3 py-1.5 text-sm font-semibold rounded-md transition-colors ${
          lang === 'ro'
            ? 'bg-regina-red text-white shadow-sm'
            : 'text-regina-gray-700 hover:bg-regina-gray-50'
        }`}
      >
        RO
      </button>
      <button
        type="button"
        onClick={() => void i18n.changeLanguage('en')}
        aria-pressed={lang === 'en'}
        className={`px-3 py-1.5 text-sm font-semibold rounded-md transition-colors ${
          lang === 'en'
            ? 'bg-regina-red text-white shadow-sm'
            : 'text-regina-gray-700 hover:bg-regina-gray-50'
        }`}
      >
        EN
      </button>
    </div>
  );
}
